<div class="grid">
	<div class="col-12">
		<div class="card" *ngIf="!permissaoInserir">
			<div style="text-align: center;">
				<h4>Você não possui permissão de acesso a essa página!</h4>
			</div>
		</div>
		<div class="card" *ngIf="permissaoInserir">
			<form #mainForm="ngForm">
				<div class="formgroup">
					<div class="p-fluid p-formgrid grid">
						
						<div *ngIf="messagemVisivel" class="field col-12 md:col-12">
							<p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
						</div>
						<div class="field col-12 md:col-6">
							<label htmlFor="descricao">Descrição do Grupo</label>
							<input oninput="this.value = this.value.toUpperCase();" pInputText type="text"
								name="descricao" ngModel #descricao="ngModel" required [(ngModel)]="grupo.descricao" />
							<div *ngIf="descricao.hasError('required') && descricao.dirty">
								<small>Campo obrigatório</small>
							</div>
						</div>
						<div class="field col-12 md:col-6">
							<label htmlFor="tipo">Tipo</label>
							<p-dropdown [options]="tipos" optionLabel="descricao" placeholder="Selecione"
								[filter]="true" emptyFilterMessage="Nenhum registro" (onChange)="selecionaTipo()"
								[(ngModel)]="planoSelecionado" name="tipo" 
								[disabled]="listaSubgrupos.length > 0"></p-dropdown>
						</div>
						<div class="field col-12 md:col-4" *ngIf="mostrarTributacao">
							<label htmlFor="tributacaoEmpresa">Tributação</label>
							<p-dropdown [options]="listaTributacoes" optionLabel="razaoSocial" placeholder="Selecione"
								name="tributacaoEmpresa" ngModel #tributacaoEmpresa="ngModel"
							(onChange)="selecionaTributacao(tributacaoEmpresa.value)"	></p-dropdown>
						</div>
					</div>
					<div class="container card col-12">
						<div class="components p-fluid p-formgrid grid">
							<div class="field col-12 md:col-3">
								<label htmlFor="descricaoSubgrupo">Subgrupo</label>
								<input oninput="this.value = this.value.toUpperCase();" pInputText type="text"
									name="descricaoSubgrupo" placeholder="Insira a descrição"
									[(ngModel)]="subgrupo.descricao" />
							</div>
							<div class="field col-12 md:col-3"
								*ngIf="tipoSelecionado && (planoSelecionado && planoSelecionado.codigo === 4)">
								<label htmlFor="rateio">Rateio básico</label>
								<p-inputNumber [(ngModel)]="subgrupo.rateioBasico" suffix="%" name="rateio"
									[max]="100" [minFractionDigits]="2" [maxFractionDigits]="2">
								</p-inputNumber>
							</div>
							<div class="field col-12 md:col-2">
								<button type="button" pButton icon="pi pi-check" class="p-button-success mt-5"
									 [disabled]="!tipoSelecionado || !subgrupo.descricao" pTooltip="Adicionar Subgrupo"
									(click)="adicionarSubgrupo()"></button>
							</div>
						</div>

						<p-table #dt1 [value]="listaSubgrupos" dataKey="id" [rows]="10" [rowHover]="true"
							styleClass="p-datatable-gridlines" [paginator]="false" responsiveLayout="scroll"
							styleClass=" p-datatable-sm" *ngIf="gridAtiva">

							<ng-template pTemplate="header">
								<tr>
									<th>
										<div class="flex justify-content-between align-items-center">
											Descrição
										</div>
									</th>
									<th *ngIf="planoSelecionado && planoSelecionado.codigo == 4">
										<div class="flex justify-content-between align-items-center">
											Rateio Básico
										</div>
									</th>
									<th>
										<div class="flex justify-content-between align-items-center">
											Ações
										</div>
									</th>
								</tr>
							</ng-template>
							<ng-template pTemplate="body" let-subgrupo>
								<tr>
									<td>
										{{ subgrupo.descricao }}
									</td>

									<td *ngIf="planoSelecionado && planoSelecionado.codigo == 4">
										{{ subgrupo.rateioBasico / 100 | percent:'1.2' }}
									</td>

									<td>
										<button pButton pRipple pTooltip="Editar" type="button" icon="pi pi-pencil"
											class="p-button-success mr-2 mb-2"
											(click)="editarSubgrupo(subgrupo)"></button>
										<button pButton pRipple pTooltip="Excluir" type="button" icon="pi pi-trash"
											class="p-button-danger mr-2 mb-2 sm"
											(click)="removerSubgrupo(subgrupo)"></button>
									</td>

								</tr>
							</ng-template>
						</p-table>
						
					</div>
					<div class="p-fluid p-formgrid grid justify-content-between">
						<div class="col-12 md:col-4">
							<button *ngIf="!progressoRequisicao" type="submit" pButton icon="pi pi-check" label="Salvar"
								class="p-button-outlined p-button-success md:w-9rem" (click)="salvar()"
								[disabled]="!mainForm.valid || !grupoValido">
							</button>
							<ng-template #exibirBotaoFalso>
								<button type="submit" pButton icon="pi pi-spin pi-spinner" label="Salvar"
									class="p-button-outlined p-button-success md:w-9rem" disabled>
								</button>
							</ng-template>
						</div>
						<div class="col-12 md:col-4 flex justify-content-end">
							<button type="button" pButton icon="pi pi-arrow-left" label="Voltar"
								class="p-button-outlined md:w-9rem" routerLink="/apps/grupo">
							</button>
						</div>
					</div>
				</div>
			</form>
			<p-dialog header="Atenção" [(visible)]="modalSubgrupo" [style]="{width: '40vw'}" [baseZIndex]="10000"
				[resizable]="false" [modal]="true" [draggable]="false">
				<p>Não há subgrupos cadastrados para o Grupo. Para salvar é necessário pelo menos um.
				</p>
				<ng-template pTemplate="footer">
					<p-button icon="pi pi-check" (click)="modalSubgrupo=false" label="OK" styleClass="p-button-primary"></p-button>
				</ng-template>
			</p-dialog>
		</div>
	</div>
</div>